import {useMantineTheme} from '@mantine/core';
import React from 'react';
import {EdgeProps} from 'reactflow';

import BaseEdgeRenderer from 'ui-library/reactflow/edges/BaseEdgeRenderer';
import {ReactFlowLockedContext} from 'ui-library/reactflow/LockedContext';

import {getEdgeStatus} from './edgeUtils';
import RemoveEdgeLabel from './RemoveEdgeLabel';

export default function TaskSchemaControlFlowEdge(props: EdgeProps): JSX.Element {
  const locked = ReactFlowLockedContext.useContext() ?? false;
  const theme = useMantineTheme();

  return (
    <>
      <BaseEdgeRenderer
        {...props}
        data={{
          ...props.data,
          hoverColor: locked ? undefined : theme.colors.blue[4],
          status: getEdgeStatus(props),
        }}
      />
      {props.selected && !locked && <RemoveEdgeLabel {...props} />}
    </>
  );
}
